import { getDiseaseTranslationKey } from 'functions/getDiseaseTranslationKey';

const getQuestionEventsMetadata = (cancerType) => {
  const cancer_type = window.t(getDiseaseTranslationKey(cancerType));
  const page_location = window.location.href;

  return {
    cancer_type,
    page_location,
  };
};

export {
  getQuestionEventsMetadata,
};
